export const CLEANUP_VENUE_STATE = 'cleanup-venue-state';
const cleanupVenueState = () => ({ type: CLEANUP_VENUE_STATE });
export default cleanupVenueState;
